import Service from '@/services/Service'

class AuthService extends Service {
  constructor() {
    super()
    this._loginURL = 'mbcommerce/auth'
    this._authUserURL = this._loginURL + '/me'
    this._logoutUrl = this._loginURL + '/logout'
  }

  async loginUser() {
    const response = await this.getAPI(this._loginURL)
    return response
  }

  async loginCompany() {
    const response = await this.getAPI(this._loginURL)
    return response
  }

  async getAuthUser(token) {
    return await this._http.post(this._authUserURL, { token: token })
  }
}

export default new AuthService()
